// readPath will take an API-like path and extract information about it

function readPath(path) {
  let objectMode =
    path.split("/").slice(-1)[0].split(".").length > 1 ? true : false
  let oName = path.split("/").slice(-1)[0].split(".")[0]

  let id
  let parentName
  let parentId

  if (objectMode === true) {
    id = path.split("/").slice(-1)[0].split(".")[1]
  }

  if (path.split("/").length > 1) {
    ;[parentName, parentId] = path.split("/").slice(-2)[0].split(".")
  }

  return { oName, id, objectMode, parentName, parentId }
}

export default readPath
